module.exports = __webpack_public_path__ + "static/img/iron-plate_256.509d87a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iron-plate_256.png
// module id = 7Mbm
// module chunks = 0